import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../utils/apk";
import { useLocation } from "react-router-dom";

const AssignedOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(getTodayDate());
  const location = useLocation();

  // Helper to format today's date as DD-MM-YYYY
  function getTodayDate() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  const fetchOrders = async (dateStr) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API}/get/all/confirm/order?date=${dateStr}`
      );
      if (response.data && response.data.success) {
        const revOrders = response.data.data.reverse();
        setOrders(revOrders);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching confirmed orders:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders(selectedDate);
  }, [selectedDate, location]);

  const handleDateChange = (e) => {
    const inputDate = new Date(e.target.value);
    const dd = String(inputDate.getDate()).padStart(2, "0");
    const mm = String(inputDate.getMonth() + 1).padStart(2, "0");
    const yyyy = inputDate.getFullYear();
    const formatted = `${dd}-${mm}-${yyyy}`;
    setSelectedDate(formatted);
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Assigned Orders</h1>

        <input
          type="date"
          className="border px-3 py-2 rounded shadow-sm text-sm"
          value={formatDateForInput(selectedDate)}
          onChange={handleDateChange}
        />
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="flex flex-wrap gap-4">
          {orders.map((order) => (
            <div
              key={order._id}
              className="bg-white shadow-md rounded-lg p-4 border border-gray-200 inline-block"
            >
              <h2 className="text-lg font-semibold mb-1">
                Order ID: {order.orderId?.orderId}
              </h2>
              <p className="text-gray-600">
                Total Price: ₹{order.orderId?.totalPrice}
              </p>
              <p className="text-gray-600">Status: {order.status}</p>

              {order.deliveryBoyId && (
                <p className="text-gray-600">
                  Delivery Boy: {order.deliveryBoyId.name}
                </p>
              )}

              <div className="mt-4">
                <h3 className="font-bold mb-2">Items:</h3>
                {order?.orderId?.addToCart?.cartIds.map((item) => (
                  <div
                    key={item._id}
                    className="border-b py-2 mb-2 last:border-b-0"
                  >
                    <p className="font-semibold text-gray-800">
                      {item.itemName}
                    </p>
                    <div className="flex flex-col ml-2 text-sm text-gray-700">
                      <span>Quantity: {item.count}</span>
                      <span className="font-medium">
                        ₹{item.itemRate.toFixed(2)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Format "DD-MM-YYYY" -> input value format "YYYY-MM-DD"
function formatDateForInput(dateStr) {
  const [dd, mm, yyyy] = dateStr.split("-");
  return `${yyyy}-${mm}-${dd}`;
}

export default AssignedOrder;
